module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Acknowledgments#fm-1"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#fm-2"
    }
  }, [_c('em', [_vm._v("Introduction: My “Happy” Ending")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Path of a Control Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: A Rutted-Out Path")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: Beneath Anger and Anxiety")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Where Am I Headed?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Eve: It Looked Good to Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: Like Looking at an Eclipse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: Kicking at Locked Doors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Role-Playing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 4: Cursed with a Craving")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Sarah: It’s Up to Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: God’s Barricading Hand")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: God’s Voice Versus Mine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Hell Hath No Fury")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 4: Never Too Old to Become Beautiful")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 5: A Family Threat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Hagar: Out from Under Her Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: Egyptian Cinderella")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: Two Counseling Questions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: A Thousand Hurdles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 4: A Mom at a Distance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 5: Opened Eyes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Rebekah: Standing In for God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: God Threads the Knot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: When One Walks Away")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Differences Can Be Wedges or Fasteners")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 4: Four Ways to Repent of Control")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 5: Standing for God Versus Standing In for Him")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Leah: Invisible and Unloved")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: An Invisible Bride")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: An Unveiled Bride")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Before I Can Give God Control")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Rachel: When She Has More")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: Family Demands")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: Compared to Her")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Thirsty Moms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 4: A Chunky Board Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Miriam: Taking the Lead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: Gifted to Lead")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: In the Lead")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Sharing Leadership")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 4: Healing a Control Girl")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Control Girl to Jesus Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 1: Reverse of the Curse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 2: Tame Your Tongue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 3: Cap the Red Pen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 4: Live Within Limits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lesson 5: Be Respectfully His")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Endnotes#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Author#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb0fd014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0